export const CreditCardDownIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M13.3334 15L15.8334 17.5M15.8334 17.5L18.3334 15M15.8334 17.5V12.5M18.3334 8.33335H1.66675M18.3334 10V6.83335C18.3334 5.89993 18.3334 5.43322 18.1518 5.0767C17.992 4.7631 17.737 4.50813 17.4234 4.34834C17.0669 4.16669 16.6002 4.16669 15.6667 4.16669H4.33342C3.39999 4.16669 2.93328 4.16669 2.57676 4.34834C2.26316 4.50813 2.00819 4.7631 1.8484 5.0767C1.66675 5.43322 1.66675 5.89993 1.66675 6.83335V13.1667C1.66675 14.1001 1.66675 14.5668 1.8484 14.9233C2.00819 15.2369 2.26316 15.4919 2.57676 15.6517C2.93328 15.8334 3.39999 15.8334 4.33341 15.8334H10.0001"
      stroke="#D92D20"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
